<template>
  <section class="container section pt-0">
    <signing-profile-datatable />
  </section>
</template>

<script>
import SigningProfileDatatable from "./signing_profile_datatable/Index.vue";

export default {
  name: "SigningProfileIndex",
  components: { SigningProfileDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
